import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'case-item',
  templateUrl: './case-item.component.html',
  styleUrls: ['./case-item.component.scss']
})
export class CaseItemComponent implements OnInit {

  @Input("data") data = null;

  constructor() { }

  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit(): void { }

}
